import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
// import './plugins/bootstrap-vue'
// bootstrap
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import VueScrollTo from 'vue-scrollto';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import axios from "axios";
window.axios = axios;

import VueRouter from 'vue-router'
import router from "./router";

import Default from "./layouts/Default.vue";
import Home from "./layouts/Home.vue";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram, faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faInstagram, faLinkedin, faFacebook)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component("default-layout", Default);
Vue.component("home-layout", Home);
Vue.use(VueRouter);
Vue.use(VueScrollTo, {
  easing: 'ease-out'
});
Vue.prototype.$http = axios;
Vue.prototype.axios = axios;
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");